module.exports = __webpack_public_path__ + "assets/images/Saiba-mais_games-digitais_c75b69076f55b99c700a00e230a20709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-four/Saiba-mais_games-digitais.png
// module id = 214
// module chunks = 0